module.exports = __webpack_public_path__ + "img/face2.12032585.jpg";